export { default } from './ListItemAvatar';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ListItemAvatar/index.js
// module id = 833
// module chunks = 2